import { render } from "./NoticePlaceholder.vue?vue&type=template&id=ffc65834&scoped=true"
import script from "./NoticePlaceholder.vue?vue&type=script&lang=js"
export * from "./NoticePlaceholder.vue?vue&type=script&lang=js"

import "./NoticePlaceholder.vue?vue&type=style&index=0&id=ffc65834&scoped=true&lang=css"

import exportComponent from "/var/www/html/vg.carvex.ee/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ffc65834"]])

export default __exports__